import mixpanel from 'mixpanel-browser';
import { Conference } from './interfaces';

export function join({ call }: Conference.Join) {
  mixpanel.track('conference:join', {
    callId: call.id,
  });
}